(() => {
  const root = document.documentElement;
  const lightingKey = "futopia-lighting-" + root.dataset.ftThemeId;
  const prepared = new WeakSet();
  const loading = new WeakMap();
  const nearby = new Set();
  let requestedLighting = root.dataset.ftLighting;
  let lightingRequest = 0;
  const originalFor = layer => layer.parentElement.querySelector(
    layer.dataset.ftNightSlot === "hover" ? ".product-card__image--secondary" :
      layer.dataset.ftNightSlot === "primary" ? ".product-card__image--primary" : ":scope > img");
  const nearViewport = layer => {
    const box = layer.parentElement.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > -160 && box.top < innerHeight + 160 && box.right > -160 && box.left < innerWidth + 160;
  };
  const ensure = layer => {
    if (loading.has(layer)) return loading.get(layer);
    const promise = new Promise(resolve => {
      const template = layer.querySelector("template[data-ft-night-template]");
      const original = originalFor(layer);
      const source = template?.content.querySelector("img");
      if (!source || !original) {
        layer.dataset.ftFailed = "missing-source";
        resolve(false);
        return;
      }
      const image = source.cloneNode(true);
      image.sizes = image.sizes.replace(/^auto,\s*/, "");
      image.fetchPriority = layer.dataset.ftNightSlot === "gallery" && layer.parentElement.classList.contains("is-initial") ? "high" : "auto";
      let settled = false;
      const finish = (ready, reason) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (ready) layer.dataset.ftReady = "true";
        else layer.dataset.ftFailed = reason;
        resolve(ready);
      };
      const timer = setTimeout(() => finish(false, "timeout"), 4500);
      image.addEventListener("error", () => finish(false, "load"), {once: true});
      const decode = async () => {
        try {
          await image.decode();
          if (!image.naturalWidth) return finish(false, "empty");
          const originalRatio = Number(original.getAttribute("width")) / Number(original.getAttribute("height"));
          if (Number.isFinite(originalRatio) && Math.abs(originalRatio - image.naturalWidth / image.naturalHeight) > .01) return finish(false, "aspect-ratio");
          const style = getComputedStyle(original);
          image.style.objectFit = style.objectFit;
          image.style.objectPosition = style.objectPosition;
          finish(true);
        } catch { finish(false, "decode"); }
      };
      image.addEventListener("load", decode, {once: true});
      layer.append(image);
      if (image.complete && image.naturalWidth) decode();
    });
    loading.set(layer, promise);
    return promise;
  };
  const observer = "IntersectionObserver" in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const layers = entry.target.querySelectorAll(":scope > .ft-card-night-layer");
      for (const layer of layers) {
        if (entry.isIntersecting) {
          nearby.add(layer);
          ensure(layer);
        } else nearby.delete(layer);
      }
    }
  }, {rootMargin: "160px"}) : null;
  const syncLighting = () => {
    document.querySelectorAll("[data-ft-lighting-toggle]").forEach(button => {
      button.setAttribute("aria-checked", String(root.dataset.ftLighting === "night"));
      if (!button.dataset.ftBound) {
        button.dataset.ftBound = "true";
        button.addEventListener("click", async () => {
          requestedLighting = requestedLighting === "night" ? "day" : "night";
          const request = ++lightingRequest;
          const target = requestedLighting;
          document.querySelectorAll("[data-ft-lighting-toggle]").forEach(toggle => toggle.setAttribute("aria-busy", "true"));
          if (target === "night") {
            const layers = [...document.querySelectorAll(".ft-card-night-layer")].filter(layer => layer.dataset.ftNightSlot === "menu" || nearViewport(layer));
            await Promise.all(layers.map(ensure));
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          }
          if (request !== lightingRequest) return;
          root.dataset.ftLighting = target;
          document.querySelectorAll("[data-ft-lighting-toggle]").forEach(toggle => toggle.removeAttribute("aria-busy"));
          try { localStorage.setItem(lightingKey, root.dataset.ftLighting); } catch {}
          syncLighting();
        });
      }
      button.hidden = false;
    });
    document.querySelectorAll(".ft-card-night-layer").forEach(layer => {
      if (!prepared.has(layer)) {
        prepared.add(layer);
        observer?.observe(layer.parentElement);
      }
      if (layer.dataset.ftNightSlot === "menu" || nearby.has(layer) || nearViewport(layer)) ensure(layer);
    });
  };
  syncLighting();
  root.dataset.ftNightBoot = "ready";
  document.addEventListener("shopify:section:load", syncLighting);
  if (!observer) addEventListener("scroll", syncLighting, {passive: true});
  let lightingFrame;
  new MutationObserver(records => {
    const relevant = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches("[data-ft-lighting-toggle],.ft-card-night-layer") || node.querySelector("[data-ft-lighting-toggle],.ft-card-night-layer"))));
    if (!relevant || lightingFrame) return;
    lightingFrame = requestAnimationFrame(() => { lightingFrame = undefined; syncLighting(); });
  }).observe(document.body, {childList: true, subtree: true});
})();


(() => {
  const selector = '[data-ft-shipping-benefits]';
  const histories = new Map();
  const initialized = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const format = (currency, amount) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 2
  }).format(amount);
  const sync = () => {
    document.querySelectorAll(selector).forEach(element => {
      if (initialized.has(element)) return;
      const currency = element.dataset.ftCurrency;
      if (window.Shopify?.currency?.active !== currency || window.Shopify?.country !== element.dataset.ftCountry) return;
      initialized.add(element);
      for (const output of element.querySelectorAll('[data-ft-shipping-amount]')) {
        const amount = Number(output.dataset.ftAmount);
        if (Number.isFinite(amount)) output.textContent = format(currency, amount) + '+';
      }
      const status = element.querySelector('[data-ft-shipping-status]');
      if (status) {
        const minor = Number(status.dataset.ftRemaining);
        if (Number.isFinite(minor) && minor >= 0) status.textContent = status.dataset.ftTemplate
          .replace('__AMOUNT__', format(currency, minor / 100)).replace('__SERVICE__', status.dataset.ftService);
      }
      const rail = element.querySelector('.ft-shipping-goals__rail');
      if (rail) rail.setAttribute('aria-valuetext', [element.querySelector('.ft-shipping-goals__headline')?.textContent.trim(), element.querySelector('.ft-shipping-benefits__note')?.textContent.trim()].filter(Boolean).join(' '));
      const fill = element.querySelector('[data-ft-goal-fill]');
      const target = Math.min(100, Math.max(0, Number(element.dataset.ftProgress)));
      if (fill && Number.isFinite(target)) {
        const key = [element.closest('#cart-drawer') ? 'drawer' : 'page', element.dataset.ftCountry, currency].join(':');
        const prior = histories.get(key);
        if (prior?.frame) cancelAnimationFrame(prior.frame);
        const from = prior?.value ?? target;
        const state = {element, fill, value: from, target, frame: 0};
        histories.set(key, state);
        const paint = value => { state.value = value; fill.style.width = value + '%'; element.dataset.ftRenderedProgress = String(value); };
        paint(from);
        if (reduced.matches || Math.abs(from - target) < .001) {
          paint(target);
          element.dataset.ftAnimating = 'false';
        } else {
          element.dataset.ftAnimating = 'true';
          const start = performance.now();
          const step = now => {
            if (!element.isConnected) return;
            const progress = Math.min(1, (now - start) / 500);
            paint(from + (target - from) * (1 - Math.pow(1 - progress, 3)));
            if (progress < 1) state.frame = requestAnimationFrame(step);
            else { state.frame = 0; element.dataset.ftAnimating = 'false'; }
          };
          state.frame = requestAnimationFrame(step);
        }
      }
      element.dataset.ftShippingReady = 'true';
    });
  };
  sync();
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
    ))) sync();
  }).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('DOMContentLoaded', sync, {once: true});
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    histories.forEach(state => {
      if (state.frame) cancelAnimationFrame(state.frame);
      state.frame = 0;
      state.value = state.target;
      state.fill.style.width = state.target + '%';
      state.element.dataset.ftRenderedProgress = String(state.target);
      state.element.dataset.ftAnimating = 'false';
    });
  });
})();
